// extracted by mini-css-extract-plugin
module.exports = {"MetaData":"Course_MetaData__2L6x_"};